import React from 'react';
import './ButtonGroup.css';

interface ButtonGroupProps {
  children: React.ReactNode;
}

function ButtonGroup({ children }: ButtonGroupProps): React.ReactElement {
  return <div className="button-group">{children}</div>;
}

export default ButtonGroup;
